export default function StackPopNull() {
    return (
        <svg className="stackPopSvg"
             aria-label="Example showing what happens when a user tries popping an element from a stack when there are no plates remaining in the pile. Simply, we ignore the requeust."
             viewBox="0 0 398 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M232.414 101.414C233.195 100.633 233.195 99.3668 232.414 98.5858L219.686 85.8579C218.905 85.0768 217.639 85.0768 216.858 85.8579C216.077 86.6389 216.077 87.9052 216.858 88.6863L228.172 100L216.858 111.314C216.077 112.095 216.077 113.361 216.858 114.142C217.639 114.923 218.905 114.923 219.686 114.142L232.414 101.414ZM167 102L231 102V98L167 98V102Z"
                fill="var(--primary)"/>
        </svg>
    )
}
